@for (message of messages; track message) {
  <glxy-alert
    [type]="getAlertType(message.severity)"
    [showAction]="true"
    actionTitle="{{ 'INTEGRATION_CARD.VERIFY_YOUR_BUSINESS' | translate }}"
    (actionClick)="navigateToAction(message.ctaUrl)"
  >
    <div [innerHTML]="message.message"></div>
  </glxy-alert>
}
